module.exports = __webpack_public_path__ + "img/yape.2678671.png";